module.exports = __webpack_public_path__ + "static/dukes.99ce75fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dukes.jpg
// module id = 629
// module chunks = 262104617495404